<template lang="pug">
#bulk-send-envelopes-card-table.template-envelopes-card-table
  .template-list
    .row.gx-3.gy-2
      .col-12.col-md-4(:key='item.hashid' v-for='(item, index) in data')
        label.templates-list-item(:for='`template-${item.id}`')
          input.checkbox.form-check-input(
            :checked='selected === item.id'
            :disabled='disableRadio'
            :id='`template-${item.id}`'
            @change='$emit("selected", item)'
            type='radio'
          )
          .card-section
            .card-section-header
              .card-section-icon.card-section-icon--green
                icon(name='file-lines')
              .card-section-title.text-break {{ item.hashid }} - {{ getEnvelopeName(item) }}
            span.text PDF-A: {{ getPdfALabel(item) }} - SANDBOX: {{ getSandboxLabel(item) }}
            span.text {{ $t('bulkSendsCardTable.createdAt') }} : {{ item.created_at | dateTime }}
            span.text {{ $t('modal.envelope.review.visibility') }} : {{ getEnvelopeVisibility(item) }}
  new-envelope-mobile-modal
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';
import CardTable from '@/ui/organisms/CardTable.vue';
import EnvelopesService from '@/modules/business/services/http/envelopes/EnvelopesService';
import EnvelopeSignaturesProgress from '@/ui/molecules/EnvelopeSignaturesProgress.vue';
import DeleteEnvelopeModal from '@/modules/business/components/organisms/modals/DeleteEnvelopeModal.vue';
import NewEnvelopeMobileModal from '@/modules/business/components/organisms/modals/NewEnvelopeMobileModal.vue';
import SimplePaginator from '@/ui/organisms/SimplePaginator.vue';

export default {
  name: 'BulkSendTemplateEnvelopesCardTable',
  components: {
    SimplePaginator,
    Icon,
    IconStatus,
    CardTable,
    EnvelopeSignaturesProgress,
    DeleteEnvelopeModal,
    NewEnvelopeMobileModal,
    EnvelopesService,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    selected: {
      type: [Number, String],
      default: null,
    },
    disableRadio: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getEnvelopeName(item) {
      return item.title && item.title !== 'old' ? item.title : item.subject;
    },
    getPdfALabel(item) {
      const label = item.metadata['envelope.type.pdfa'] ? 'Yes' : 'No';
      return this.$t(`${label}`);
    },
    getSandboxLabel(item) {
      const sandbox = item?.is_sandbox === 0 ? 'No' : 'Yes';
      return this.$t(`${sandbox}`);
    },
    getEnvelopeVisibility(item) {
      const visibility = item?.visibility ?? '';
      return visibility
        ? this.$t(`modal.envelope.review.visibilityOptions.${visibility}`)
        : this.$t('modal.envelope.visibilityUnset');
    },
  },
};
</script>
<style lang="stylus">
.templates-list-item
  border-radius: 3px
  padding: 0.54rem 1rem
  box-shadow: 0px 0px 3px 1px #dadada
  cursor: pointer
  position: relative
  padding-left: 1.7rem
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  color: #555555
  width: 100%
  font-size: 0.875rem
  .checkbox
    position: absolute
    left: 7px
    top: 0.7rem

.pagination-space
  display: inline-block

.card-section
  & + .card-section
    margin-top: 1.25rem
    padding-top: 1.25rem
    border-top: 1px solid rgba(204, 204, 204, .5)

.card-section-header
  display: flex
  align-items: center
  gap: 0.75rem
  margin-bottom: 1rem

.card-section-icon
  display: flex
  align-items: center
  justify-content: center
  flex: 0 0 auto
  width: 2rem
  height: 2rem
  border-radius: 50%
  font-size: 0.9rem

  &--green
    background-color: #E7F0EF
    color: #19665B

  &--blue
    background-color: #EAF1FB
    color: #2C6FBB

.card-section-title
  font-weight: 600
  font-size: 0.95rem

#bulk-send-envelopes-card-table
  .templates-list-item
    display: block
    white-space: normal
    overflow: visible
    text-overflow: clip

  .card-section-header
    align-items: center

  .card-section-title
    flex: 1
    min-width: 0
    white-space: normal
    overflow-wrap: anywhere

  .card-section > span.text
    display: block
    white-space: normal
    overflow-wrap: anywhere

    & + span.text
      margin-top: 0.25rem
</style>
